import auth from '@/modules/auth/services'
import contato from '@/components/contato/services'
import produtos from '@/modules/produtos/services'

export default {
    auth,
    contato,
    produtos
}
